import { Tooltip } from '@gisce/oficina-virtual-components'
import {
  Card, CardContent, Typography, Box,
  Grid, Button, IconButton,
} from '@mui/material';
import { CreateOutlined } from '@mui/icons-material';
import TextFieldEdit from "../../../TextFieldEdit/TextFieldEdit";
import { useTranslation } from 'react-i18next';
import { ContractDisplayTypes, ContractModificationTypes } from '../../types/contracts';
import { useSettingsContext } from '@/components/Settings/hooks/useSettingsContext';
import useAuth from '@/components/Authentication/hooks/useAuth';
// import ContractElectronicNotification from './components/ElectronicNotificationAction';
import { useContracts } from '../../hooks/useContracts';
import TextFieldReadOnly from '@/components/TextFieldReadOnly/TextFieldReadOnly';

interface IContactDetailsPanelProps {
  type: ContractDisplayTypes;
  openDialog: (type: ContractModificationTypes) => void;
}

export const ContactDetailsPanel = ({
  type,
  openDialog
}: IContactDetailsPanelProps) => {
  const { t } = useTranslation();
  const Settings = useSettingsContext();
  const { tokenVals } = useAuth();
  const { 
    onUpdateNotificationPhone,
    onUpdateNotificationEmail,
    currentContract: contract
  } = useContracts(type);
  
  const tokenReadOnly = tokenVals?.readonly;

  return contract && <Card sx={{marginBottom: 3}}>
    <CardContent>
      <Box>
        <Grid container alignItems={'center'}>
          <Grid item>
            <Typography variant="h5">
              {t('common:text.contract_contact_data')}
            </Typography>
          </Grid>
          <Grid item>
            {Settings.features?.notificacionAddressChange &&
              contract.state === 'activa' && 
              <Tooltip
                title={tokenReadOnly &&
                  t("common:text.token_readonly_tooltip")
                }
                placement="right"
                arrow
                disableFocusListener={!tokenReadOnly}
                disableHoverListener={!tokenReadOnly}
                disableTouchListener={!tokenReadOnly}
                slotProps={{
                  popper: {
                    modifiers: [{
                      name: 'offset',
                      options: {offset: [0, -5]}
                    }]
                  }
                }}
              >
                <span style={{ 'width': '100%' }}>
                  <IconButton
                    key={'modifyAddress'}
                    color={'primary'}
                    disabled={!!tokenReadOnly}
                    title={t('common:text.contract_modification')}
                    onClick={() => openDialog("address")}
                  >
                    {<CreateOutlined/>}
                    {/* {t('common:text.contract_modification')} */}
                  </IconButton>
                </span>
              </Tooltip>
            }
          </Grid>
        </Grid>
      </Box>
      <Grid container>
        <Grid item xs={12}>
          <TextFieldReadOnly
            label={t('common:text.address_name')}
          >
            {contract.notification_address?.name}
          </TextFieldReadOnly>
        </Grid>
        
        <Grid item xs={12} md={6}>
          {(!Settings.contract?.addressChange?.enableExisting && !contract.notification_address.mobile) ?
            <TextFieldEdit
              label={t('common:text.contract_contact_data_phone')}
              onUpdated={onUpdateNotificationPhone}
            />
            :
            <TextFieldReadOnly
              label={t('common:text.contract_contact_data_phone')}
            >
              {contract.notification_address.mobile ?
                contract.notification_address.mobile
                :
               <Typography variant="subtitle1" sx={{ color: "grey" }}>
                  {t('common:text.contract_contact_data_phone_not_set')}
               </Typography>
              }
            </TextFieldReadOnly>
          }
        </Grid>
        <Grid item xs={12} md={6}>
          {(!Settings.contract?.addressChange?.enableExisting && !contract.notification_address.email) ?
            <TextFieldEdit
              label={t('common:text.contract_contact_data_email')}
              onUpdated={onUpdateNotificationEmail}
            />
            :
            <TextFieldReadOnly
              label={t('common:text.contract_contact_data_email')}
            >
            {contract.notification_address.email
              ? contract.notification_address.email
              :
              <Typography variant="subtitle1" sx={{ color: "grey" }}>
                  {t('common:text.contract_contact_data_email_not_set')}
              </Typography>
            }
          </TextFieldReadOnly>
          }
        </Grid>
        <Grid item xs={12} md={6}>
          <TextFieldReadOnly
            label={t('common:text.contract_contact_data_address')}
          >
            {contract.notification_address.full_address}
          </TextFieldReadOnly>
        </Grid>
        <Grid item xs={12} md={6}>
          <TextFieldReadOnly label={t('common:text.contract_contact_data_send_type')}>
            {contract.invoice_online === 'email' && t('common:text.invoice_online_email')}
            {contract.invoice_online === 'postal' && t('common:text.invoice_online_postal')}
            {contract.invoice_online === 'postal+email' && t('common:text.invoice_online_postal_and_email')}
          </TextFieldReadOnly>
        </Grid>
      </Grid>
    </CardContent>
  </Card>
}